import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../components/Preloader";
import HeroBanner from "./contents/home/HeroBanner";

const Whychoose = lazy(() => import("./contents/home/Whychoose"));
const Howitworks = lazy(() => import("./contents/home/Howitworks"));
const Testimonials = lazy(() => import("./contents/home/Testimonials"));
const Faqs = lazy(() => import("./contents/home/Faqs"));
const Footer = lazy(() => import("../components/footer/Footer"));

const Home = () => {
  return (
    <>
    <Helmet>
      <title>NeuraAcademy — Data Privacy & Compliance Certification for Healthcare Professionals</title>
      <meta name="description" content="Certify your clinic's compliance with NeuraAcademy's expert-led program. Designed for Speech-Language Pathologists, Audiologists, and Communication Health Assistants. Self-paced PHIPA, digital ethics, and AI compliance training with digital certificates." />
      <meta property="og:title" content="NeuraAcademy — Data Privacy & Compliance Certification for Healthcare Professionals" />
      <meta property="og:description" content="Certify your clinic's compliance. Expert-led PHIPA, digital ethics, and AI compliance training for SLPs, Audiologists, and Communication Health Assistants across Canada." />
      <meta property="og:url" content="https://neuraspeech.com/" />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://neuraspeech.com/" />
    </Helmet>
    <Preloader />
    <HeroBanner />
    <Suspense fallback={<div />}>
    <Whychoose />
    <Howitworks />
    <Testimonials />
    <Faqs />
    <Footer />
    </Suspense>
    <button type="button" id="backtotop">
      <i className="ri-arrow-up-line" />
    </button>
</>
  );
};

export default Home;
